<template>
  <div>
    <Topbar></Topbar>

    <div class="container">
      <div class="row">
        <div class="col">
          <h1 class="mt-5">Administrative</h1>
          <form>
            <div class="row">
              <div class="form-group col-3">
                <div class="input-group mb-2">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <span class="oi oi-person" title="person" aria-hidden="true"></span>
                    </div>
                  </div>
                  <b-form-select placeholder="Username" v-model="selectedUserId" :options="users" value-field="id" text-field="username"></b-form-select>
                </div>
              </div>
              <div class="col-9">
                <button type="button" class="btn btn-danger" @click="deleteUser">Deactivate user</button>
                <button type="button" data-toggle="modal" data-target="#edit-user" class="btn btn-warning" @click="$refs.editUser.show()">Edit user</button>
                <button type="button" data-toggle="modal" data-target="#add-user" class="btn btn-success" @click="$refs.addUser.show()">Add user</button>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-3">
                <div class="input-group mb-2">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <span class="oi oi-person" title="person" aria-hidden="true"></span>
                    </div>
                  </div>
                  <b-form-select placeholder="Project name" v-model="selectedProjectId" :options="projects.items" value-field="id" text-field="name"></b-form-select>
                </div>
              </div>
              <div class="col">
                <button type="button" class="btn btn-danger" @click="cancelProject">Delete project</button>
<!--                <button type="button" class="btn btn-warning">Edit project</button>-->
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
    <b-modal ref="editUser" id="edit-user" size="lg">

      <template slot="modal-header">
        <h2 class=""><span>Edit user settings</span></h2>
      </template>

      <template slot="default" >
        <div class="container control-group">
          <form v-if="editedUser">
            <div class="row">
              <div class="col-12 mt-1">
                <label class="text-secondary" for="newUsername">Username
                </label>
              </div>
              <div class="form-group col-6">
                <div class="input-group mb-1">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <span class="oi oi-person" title="person" aria-hidden="true"></span>
                    </div>
                  </div>
                  <input type="text" class="form-control" id="newUsername"
                         v-model="editedUser.username">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <label class="text-secondary" for="newPassword">Password
                </label>
              </div>
              <div class="form-group col-6">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <span class="oi oi-person" title="person" aria-hidden="true"></span>
                    </div>
                  </div>
                  <input type="text" class="form-control" id="newPassword"
                         placeholder="********" v-model="editedUser.password">
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12">
                <label class="text" for="radioButton">User privileges
                </label>
              </div>
              <div class="col">
                <div class="radio">
                  <label><input type="radio" v-model="editedUser.role" name="privileges" value="Manager">Manager</label>
                </div>
                <div class="radio">
                  <label><input type="radio" v-model="editedUser.role" name="privileges" value="Portfolio Manager">Project manager</label>
                </div>
                <div class="radio disabled">
                  <label><input type="radio" v-model="editedUser.role" name="privileges" value="Admin">Administrator</label>
                </div>
              </div>
            </div>
          </form>
          <h2 v-else>
            Select user first please.
          </h2>
        </div>
      </template>

      <template slot="modal-footer">
        <div class="row-5 justify-content-center">
          <input class="btn btn-success" type="submit" @click="editUser" value="Save changes"/>
        </div>
      </template>
    </b-modal>

    <b-modal ref="addUser" id="add-user" size="lg">

      <template slot="modal-header">
        <h2 class=""><span>Create an account</span></h2>
      </template>

      <template slot="default" >
        <div class="container control-group">
          <form>
            <div class="row">
              <div class="col-7">
                <div class="row">
                  <div class="col-12">
                    <label class="text-secondary" for="create-email">Email
                    </label>
                  </div>
                  <div class="form-group col-6">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <div class="input-group-text">
                          <span class="oi oi-person" title="person" aria-hidden="true"></span>
                        </div>
                      </div>
                      <input type="text" class="form-control" id="create-email"
                             placeholder="Email" v-model="newUser.email">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <label class="text-secondary" for="create-username">Username
                    </label>
                  </div>
                  <div class="form-group col-6">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <div class="input-group-text">
                          <span class="oi oi-person" title="person" aria-hidden="true"></span>
                        </div>
                      </div>
                      <input type="text" class="form-control" id="create-username"
                             placeholder="Username" v-model="newUser.username">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <label class="text-secondary" for="create-password">Password
                    </label>
                  </div>
                  <div class="form-group col-6">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <div class="input-group-text">
                          <span class="oi oi-person" title="person" aria-hidden="true"></span>
                        </div>
                      </div>
                      <input type="text" class="form-control" id="create-password"
                             placeholder="********" v-model="newUser.password">
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-4">
                <div class="row-5">
                  <div class="col-12">
                    <label class="text textprivileges" for="radioButton">User privileges
                    </label>
                  </div>
                  <div class="col">
                    <div class="radio">
                      <label><input type="radio" v-model="newUser.role" value="Manager" name="privileges" checked id="radioButton">Manager</label>
                    </div>
                    <div class="radio">
                      <label><input type="radio" v-model="newUser.role" value="Portfolio Manager" name="privileges">Project manager</label>
                    </div>
                    <div class="radio disabled">
                      <label><input type="radio" v-model="newUser.role" value="Admin" name="privileges">Administrator</label>
                    </div>
                  </div>
                </div>
                <br/>
              </div>
            </div>
          </form>
        </div>
      </template>

      <template slot="modal-footer">
        <input class="btn btn-success" type="submit" @click="addUser" value="Create"/>
      </template>
    </b-modal>

  </div>
</template>

<script>
import Topbar from '../components/Topbar'
import { projectPhases } from '../store'
export default {
  name: 'Admin',
  components: {
    Topbar
  },
  computed: {
    users () {
      return this.$store.getters.users
    },
    projects () {
      return this.$store.getters.projects
    },
    phasesIds () {
      return this.$store.getters.getAllPhasesIds
    },
    editedUser: {
      get () {
        return this.users.find(u => u.id === this.selectedUserId)
      },
      set (newVal) {
        console.log(newVal)
      }
    }
  },
  mounted () {
    this.loadProjects()
  },
  methods: {
    editUser () {
      this.axios.put(this.$serverAddr + '/user/' + this.editedUser.id, this.editedUser).then((response) => {
        this.$bvToast.toast(response.data, {
          title: 'Success',
          autoHideDelay: 5000,
          variant: 'success'
        })
      })
    },
    addUser () {
      this.axios.post(this.$serverAddr + '/user', this.newUser).then((response) => {
        this.$bvToast.toast(response.data, {
          title: 'Success',
          autoHideDelay: 5000,
          variant: 'success'
        })
      })
    },
    deleteUser () {
      this.axios.delete(this.$serverAddr + '/user/' + this.editedUser.id).then((response) => {
        this.$bvToast.toast(response.data, {
          title: 'Success',
          autoHideDelay: 5000,
          variant: 'success'
        })
      })
    },
    loadProjects () {
      this.$store.dispatch('loadProjects', {
        phases: this.phasesIds,
        name: '',
        page: 1,
        perPage: 200,
        sortBy: 'id',
        desc: 'ASC',
        users: '',
        start_dates: '',
        end_dates: ''
      })
    },
    cancelProject () {
      let project = this.projects.items.find(p => p.id === this.selectedProjectId)
      this.axios.delete(this.$serverAddr + '/project/' + project.id).then((response) => {
        this.$bvToast.toast(response.data, {
          title: 'Success',
          autoHideDelay: 5000,
          variant: 'success'
        })
      })

      // let projectId = this.projects.findIndex(p => p.id === this.selectedProjectId)
      // if (projectId !== -1) {
      //   this.projects[projectId].phases.push({
      //     start_date: Date.now(),
      //     end_date: null,
      //     responsible_user: this.user,
      //     phase: this.phases[10]
      //   })
      //   this.save()
      // }
    },
    save () {
      let payload = JSON.parse(JSON.stringify(this.projects.find(p => p.id === this.selectedProjectId)))
      payload.portfolio_manager = payload.portfolio_manager ? payload.portfolio_manager[0] : null
      payload.resolution = payload.resolution ? payload.resolution[0] : null
      payload.intent = payload.intent ? payload.intent[0] : null
      payload.matrix = payload.matrix ? payload.matrix[0] : null
      for (let phase of payload.phases) {
        if (phase.responsible_user.length > 0) {
          phase.responsible_user = phase.responsible_user[0]
        }
      }
      this.axios.put(this.$serverAddr + '/project/' + payload.id, payload).then((response) => {
        this.$bvToast.toast(response.data, {
          title: 'Success',
          autoHideDelay: 5000,
          variant: 'success'
        })
      })
    }
  },
  data () {
    return {
      selectedUserId: null,
      phases: projectPhases,
      newUser: {
        email: '',
        username: '',
        password: '',
        role: '',
        selectedProjectId: null
      }
    }
  }
}
</script>

<style scoped>

</style>
